import { render, staticRenderFns } from "./SalesSummaryReport.vue?vue&type=template&id=2b0a9424&"
import script from "./SalesSummaryReport.vue?vue&type=script&lang=js&"
export * from "./SalesSummaryReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports